<template>
    <VListItemGroup v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    </VListItemGroup>
</template>

<script>
const ELEMENT_CLASS = 'sr-list-item-group';

export default {
    name: 'SrListItemGroup',
    computed: {
        classList() {
            return [ELEMENT_CLASS];
        },
    },
};
</script>
